module.exports = __webpack_public_path__ + "img/icon4.1d3707f3.png";